export const MIN_ADVERTISEMENTS = 1
export const DEFAULT_ADVERTISEMENTS = 16
export const ADVERTISEMENTS_COLOR = '#fd4b84'
export const VOOH_SCHEDULE_HEIGHT = '700px'
export const BUMPER_COLOR = '#0cf8f8'
export const MIN_NOMINAL_DURATION = 15
export const MAX_NOMINAL_DURATION = 1440